






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UPDATE_CONTRA_ENTRY } from '../../../store/financeAccount';
import { ApiResponse } from '@/components/types';
import { Transaction, UpdateContraEntry } from '../../../types';
import { createUpdateContraEntry } from '@/modules/listOfAssets/model';

const FinanceAccount = namespace('listOfAssets/financeAccount');

@Component({})
export default class UpdateTransactionDialog extends Vue {
  @Prop({ type: Object }) transaction!: Transaction | null;

  @FinanceAccount.Action(UPDATE_CONTRA_ENTRY) updateContraEntry!: (transaction: UpdateContraEntry) => Promise<ApiResponse>;

  error: any = null;
  dialog: boolean = false;
  value: UpdateContraEntry | null = null;

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (value !== false) return;

    setTimeout(() => {
      this.error = null;
      this.dialog = false;
      this.value = null;
      this.$emit('update:transaction', null);
    }, 200);
  }

  @Watch('transaction')
  watchTransaction(transaction: Transaction) {
    if (!transaction) return;

    this.value = createUpdateContraEntry(transaction);

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  async save() {
    if (!this.value) return;

    this.error = null;

    return this.updateContraEntry(this.value);
  }
}
